import { CvaMarketingActionButtonProps } from '../../types';
import { CatButton } from '@blocks-react/components/Button';
import { Link } from '../../../common/link';
import { useMemo } from 'react';

export const CvaMarketingActionButton = ({
  hideCatButton,
  showLinkBtn,
  buttonLabel,
  href
}: CvaMarketingActionButtonProps) => {
  const labelContainer = useMemo(() => {
    return <span className="text-capitalize">{buttonLabel}</span>;
  }, [buttonLabel]);

  return (
    <div>
      {!hideCatButton && (
        <CatButton href={href} data-testid="marketing-learn-more-btn">
          {labelContainer}
        </CatButton>
      )}
      {showLinkBtn && (
        <Link href={href} noPadding>
          {labelContainer}
        </Link>
      )}
    </div>
  );
};
